import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CurrencyItem from '../../../../components/CurrencyItem';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';
import { sendSlice } from '../../../../store/slices';

import './SendAsset.scss';

const { routes } = AppConfig;

const SendAsset = () => {
	const availableCurrencies = useSelector(store => store.app.availableCurrencies);

	// const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const sortedCurrencies = [...availableCurrencies].sort((a, b) => b.AmountUsd - a.AmountUsd);

	const selectAsset = asset => {
		dispatch(sendSlice.actions.setSendData({ asset }));
		navigate({ pathname: routes.sendAccount });
		// navigate(
		// 	{ pathname: routes.sendAccount, search: createSearchParams({ currencyId: asset.Id }).toString() },
		// 	location
		// );
	};

	return (
		<div className='SendAsset'>
			<PageHeader header={'Select asset to send'} />
			<div className='SendAsset__container FormBlock'>
				{sortedCurrencies.map((currency, index) => (
					<CurrencyItem
						key={index}
						currency={currency}
						lastItem={index === sortedCurrencies.length - 1}
						onClick={selectAsset}
					/>
				))}
			</div>
		</div>
	);
};

export default SendAsset;
